
import React, { Component } from 'react'
import * as actions from "../actions";
import * as utils from "../../utils";

const SlideshowOverlayAd = React.createClass({
  shouldComponentUpdate() {
    return false;
  },
  componentDidMount: function() {
    if (utils.isMobile()) {
      this.mountMobileAd();
    } else {
      this.mountDesktopAd();
    }
  },
  render() {
    return (
      <div className="slideshow-overlay-ad" onClick={this.handleOuterClick}>
        <a href="#" className="button-primary restart-button" onClick={this.handleButtonClick}>
          Restart Slideshow
        </a>
        <div className="ad-wrap">
          <p className="ad-label"><span>paid advertisement</span></p>
          <div id="div-gpt-slideshow-overlay-ad" className="gpt-ad" />
        </div>
        <div className="prev-next">
          <a href="javascript: void();" className="next">
            <span className="icon-arrow-right"></span>
          </a>
          <a href="#" className="previous" onClick={this.handlePrevButtonClick}>
            <span className="icon-arrow-left"></span>
          </a>
        </div>
      </div>
    );
  },
  handlePrevButtonClick(e) {
    e.preventDefault();
    $('.swipeshow').swipeshow().goTo($('.slide').length - 1);
  },
  handleOuterClick() {
    this.closeOverlayAd();
  },
  handleButtonClick(e) {
    e.preventDefault();
    this.closeOverlayAd();
  },
  closeOverlayAd() {
    actions.setOverlayAdVisible(false);
  },
  mountDesktopAd() {
    if (window.slideshowOverlayAd) {
      googletag.pubads().refresh([window.slideshowOverlayAd]);
    } else {
      googletag.cmd.push(function() {
        window.slideshowOverlayAd = googletag.defineSlot(
          `${window.dfp_desktop_id}/${desktop_slot3()}/photos`,
          [[8, 7]],
          "div-gpt-slideshow-overlay-ad"
        )
        .addService(googletag.pubads());
        googletag.display('div-gpt-slideshow-overlay-ad');
      });
    }
  },
  mountMobileAd() {
    if (window.slideshowOverlayAd) {
      googletag.pubads().refresh([window.slideshowOverlayAd]);
    } else {
      googletag.cmd.push(function() {
        window.slideshowOverlayAd = googletag.defineSlot(
          `${window.dfp_mobile_id}/${desktop_slot3()}/photos`,
          [[300, 250]],
          "div-gpt-slideshow-overlay-ad"
        )
        .addService(googletag.pubads());
        googletag.display('div-gpt-slideshow-overlay-ad');
      });
    }
  }
});

export default SlideshowOverlayAd;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/slideshow/components/slideshow-overlay-ad.es6